import { Row, Col, Input, Select, Button, Space } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { getProveedoresPO } from "../../../../services/financiero/ingresosPO/proveedoresPOService";
import { getProyectosPO } from "../../../../services/financiero/ingresosPO/catalogosPOService";
import { filterOption } from "../../ingresosPOCardStyles";
import ExportOrdenesServicioPOButton from "./ExportOrdenesServicioPOButton";
const { Option } = Select;

export default function OrdenesServicioPOFilters({ onFilter, filteredProductos, permissionExport }) {

  const [proveedores, setProveedores] = useState([]);
  const [proyectos, setProyectos] = useState([]);

  const [filters, setFilters] = useState({
    search: "",
    po: "",
    proveedor: null,
    proyecto: null,
  });

  useEffect(() => {
    cargarCatalogos();
  }, []);

  const cargarCatalogos = async () => {
    try {
      const [prov, proy] = await Promise.all([getProveedoresPO(), getProyectosPO()]);
      setProveedores(prov);
      setProyectos(proy);
    } catch (error) {
      console.error("Error cargando filtros");
    }
  };

  const handleChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFilter?.(newFilters);
  };

  const limpiarFiltros = () => {
    const empty = { search: "", po: "", proveedor: null, proyecto: null };
    setFilters(empty);
    onFilter?.(empty);
  };

  return (
    <Row gutter={[12, 12]} style={{ marginBottom: 20 }}>
      <Col xs={24} md={6}>
        <Input allowClear placeholder="Buscar producto o descripción" prefix={<SearchOutlined />} value={filters.search} onChange={(e) => handleChange("search", e.target.value)} />
      </Col>
      <Col xs={24} md={3}>
        <Input allowClear placeholder="Número PO" value={filters.po} onChange={(e) => handleChange("po", e.target.value)} />
      </Col>
      <Col xs={24} md={5}>
        <Select allowClear showSearch filterOption={filterOption} placeholder="Proveedor" style={{ width: "100%" }} value={filters.proveedor} onChange={(value) => handleChange("proveedor", value)}>
          {proveedores.map((p) => (
            <Option key={p.oid} value={p.oid}>{[p.identificacion, p.nombre].filter(Boolean).join(" - ")}</Option>
          ))}
        </Select>
      </Col>
      <Col xs={24} md={5}>
        <Select allowClear showSearch filterOption={filterOption} placeholder="Proyecto" style={{ width: "100%" }} value={filters.proyecto} onChange={(value) => handleChange("proyecto", value)}>
          {proyectos.map((p) => (
            <Option key={p.oid} value={p.oid}>{p.codigo} - {p.proyecto}</Option>
          ))}
        </Select>
      </Col>
      <Col xs={24} md={1}>
        <Space>
          <Button icon={<ClearOutlined />} onClick={limpiarFiltros} />
        </Space>
      </Col>
      {permissionExport && (
        <div style={{ marginBottom: 16 }}>
          <ExportOrdenesServicioPOButton data={filteredProductos} />
        </div>
      )}
    </Row>
  );
}
